import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { OrderProvider } from './contexts/OrderContext';
import { FunnelMap } from './components/FunnelMap';
import { MetaPixel } from './components/MetaPixel';
import { BridgePage } from './pages/BridgePage';
import { SalesPage } from './pages/SalesPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { Oto1Page } from './pages/Oto1Page';
import { ThankYouPage } from './pages/ThankYouPage';
import { RetargetingPage } from './pages/RetargetingPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjpy1kz9roig">
      <OrderProvider data-id="element-1" data-mp="31agmqk5ke7hc">
        <div className="w-full min-h-screen bg-cream font-body text-ink" data-id="element-2" data-mp="31ayqe1uk3nza">
          <MetaPixel data-id="element-3" data-mp="2wka18t6cn33b" />
          <Routes data-id="element-4" data-mp="2wjqgl4pbe0ll">
            <Route path="/" element={<BridgePage data-id="element-6" data-mp="2whx9joashed2" />} data-id="element-5" data-mp="2wj8e3qc26q58" />
            <Route path="/protocolo" element={<SalesPage data-id="element-8" data-mp="28te2fc3h77mk" />} data-id="element-7" data-mp="28u5yeo0zj7dd" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-10" data-mp="23vcm2yxfpmes" />} data-id="element-9" data-mp="28sl511qepuh3" />
            <Route path="/oferta-especial" element={<Oto1Page data-id="element-12" data-mp="23t8hsfvmildz" />} data-id="element-11" data-mp="23u9tmmkgrbwr" />
            <Route path="/gracias" element={<ThankYouPage data-id="element-14" data-mp="3iiweam7rne26" />} data-id="element-13" data-mp="3ik7gwiph6frp" />
            <Route path="/retargeting" element={<RetargetingPage data-id="element-16" data-mp="3mlawr57iwbsx" />} data-id="element-15" data-mp="3ijpcuzwkmx98" />
          </Routes>
          <FunnelMap data-id="element-17" data-mp="3mjzu58ptda3e" />
        </div>
      </OrderProvider>
    </BrowserRouter>;
}